import axios from '@axios'

const PANEL_INFO_REQUEST_TIMEOUT = 35000

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(dvr => ({
        value: dvr.id,
        label: dvr.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getInfo({ commit }, params) {
      try {
        const { data } = await axios.get('v1/services/alarm-panel/info', {
          params,
          // Keep the popover loader from waiting forever on a stalled request.
          timeout: PANEL_INFO_REQUEST_TIMEOUT,
        })

        if (!data) {
          return []
        }

        commit('setData', data.data);
        return data;

      } catch (error) {
        console.error('Error fetching items:', error);
        return [];
      }
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
